import _defineProperty from"/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";function ownKeys(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);r&&(o=o.filter(function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable;})),t.push.apply(t,o);}return t;}function _objectSpread(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys(Object(t),!0).forEach(function(r){_defineProperty(e,r,t[r]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys(Object(t)).forEach(function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r));});}return e;}import{gql}from'@apollo/client';import*as Apollo from'@apollo/client';const defaultOptions={};/** All built-in and custom scalars, mapped to their actual values */export let CacheControlScope=/*#__PURE__*/function(CacheControlScope){CacheControlScope["Private"]="PRIVATE";CacheControlScope["Public"]="PUBLIC";return CacheControlScope;}({});export let EpisodeType=/*#__PURE__*/function(EpisodeType){EpisodeType["Catchup"]="CATCHUP";EpisodeType["LiveBefore"]="LIVE_BEFORE";EpisodeType["LiveOnair"]="LIVE_ONAIR";EpisodeType["Video"]="VIDEO";return EpisodeType;}({});export let TermType=/*#__PURE__*/function(TermType){TermType["Optional"]="OPTIONAL";TermType["Required"]="REQUIRED";return TermType;}({});export const RoomConfigFieldsFragmentDoc=gql`
    fragment roomConfigFields on ChatRoomConfig {
  messageLimit
  pollingInterval
  initialMessageLimit
  userLimit
}
    `;export const RoomCustomDataFieldsFragmentDoc=gql`
    fragment roomCustomDataFields on ChatRoomCustomData {
  type
  liveStartBefore
  liveEndAfter
  skipMessageThreshold
  appMessageLimit
  chatEndDateTime
}
    `;export const RoomFieldsFragmentDoc=gql`
    fragment roomFields on ChatRoom {
  roomId
  config {
    ...roomConfigFields
  }
  customData {
    ...roomCustomDataFields
  }
}
    ${RoomConfigFieldsFragmentDoc}
${RoomCustomDataFieldsFragmentDoc}`;export const SenderFieldsFragmentDoc=gql`
    fragment senderFields on Sender {
  displayName
  refId
  id
}
    `;export const DeviceInfoFieldsFragmentDoc=gql`
    fragment deviceInfoFields on DeviceInfo {
  browser {
    major
    name
    version
  }
  deviceType
  deviceVendor
  isAndroid
  isBot
  isChrome
  isChromeOS
  isDesktop
  isEdge
  isFirefox
  isIE
  isIOS
  isIPad
  isIPhone
  isMac
  isMobile
  isSafari
  isTablet
  isWindows
  os {
    major
    name
    version
  }
  ua
  isWebView @client(always: true)
  isApp
}
    `;export const PageInfoFieldsFragmentDoc=gql`
    fragment pageInfoFields on PageInfo {
  offset
  limit
  totalCount
  hasNextPage
}
    `;export const AdvertisingFieldsFragmentDoc=gql`
    fragment advertisingFields on Advert {
  id
  name
  description
  url
  targetBlank
  sort
  thumbnailUrl
  copyright
}
    `;export const ChannelMetaFieldsFragmentDoc=gql`
    fragment channelMetaFields on ChannelMeta {
  id
  schema_key
  name
  header
  description
  thumbnailUrl
  copyright
  delivery_start_at
  delivery_end_at
  rights_control_type
  rating
  isAllowedRating
  rights {
    ... on Right {
      id
      name
      price
      contractAllowed
    }
  }
  genres {
    id
    name
  }
  meta_keywords
  meta_description
  live_flag
  video_flag
  heroImage {
    pc
    mb
  }
  distributor
}
    `;export const EpisodeMetaFieldsFragmentDoc=gql`
    fragment episodeMetaFields on EpisodeMeta {
  id
  schema_key
  name
  header
  description
  thumbnailUrl
  copyright
  delivery_start_at
  delivery_end_at
  rights_control_type
  rating
  isAllowedRating
  rights {
    ... on Right {
      id
      name
      price
    }
  }
  genres {
    id
    name
  }
  production_country
  production_year
  distributor
  cast
  staff
  duration
  meta_keywords
  meta_description
  channel {
    ... on ChannelMeta {
      id
      name
    }
  }
  tvShow {
    ... on TVShowMeta {
      id
      name
      episode_num
    }
  }
  area_control_flag
  is_live
  recommend
  start_over_flag
  catch_up_flag
  encode_start_date
  encode_end_date
  source_epg_id
  plalaFlag
}
    `;export const LiveMetaFieldsFragmentDoc=gql`
    fragment liveMetaFields on LiveMeta {
  id
  schema_key
  name
  header
  description
  thumbnailUrl
  copyright
  delivery_start_at
  delivery_end_at
  rights_control_type
  parents {
    ... on TVShowMeta {
      id
      name
      episode_num
    }
  }
  rating
  isAllowedRating
  rights {
    ... on Right {
      id
      name
      price
    }
  }
  genres {
    id
    name
  }
  production_country
  production_year
  distributor
  cast
  staff
  duration
  meta_keywords
  meta_description
  channel {
    ... on ChannelMeta {
      id
      name
    }
  }
  tvShow {
    ... on TVShowMeta {
      id
      name
      episode_num
    }
  }
  area_control_flag
  is_live
  recommend
  start_over_flag
  catch_up_flag
  encode_start_date
  encode_end_date
  source_epg_id
  plalaFlag
}
    `;export const TvShowMetaFieldsFragmentDoc=gql`
    fragment tvShowMetaFields on TVShowMeta {
  id
  schema_key
  name
  header
  description
  thumbnailUrl
  copyright
  delivery_start_at
  delivery_end_at
  rights_control_type
  rating
  isAllowedRating
  rights {
    ... on Right {
      id
      name
      price
      rights_control_type
    }
  }
  genres {
    id
    name
  }
  production_country
  production_year
  cast
  staff
  episode_num
  meta_keywords
  meta_description
  channel {
    ... on ChannelMeta {
      id
      name
    }
  }
  distributor
}
    `;export const EntitlementFieldsFragmentDoc=gql`
    fragment entitlementFields on Entitlement {
  id
  user_id
  right_id
  start_at
  end_at
  exercised_at
  exercise_duration
  exercise_duration_unit
  exercisable_start_at
  exercisable_end_at
  suspend_flag
}
    `;export const CampaignFieldsFragmentDoc=gql`
    fragment campaignFields on Campaign {
  id
  name
  header
  description
  validityStartAt
  validityEndAt
  discountApplyCount
}
    `;export const CoursePriceFieldsFragmentDoc=gql`
    fragment coursePriceFields on CoursePrice {
  id
  price
  payment_amount
  validity_start_at
  validity_end_at
  campaignId
  campaign {
    ...campaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;export const CourseFieldsFragmentDoc=gql`
    fragment courseFields on Course {
  id
  name
  thumbnailUrl
  description
  validity_start_at
  validity_end_at
  price
  priceWithoutTax
  defaultPrice
  defaultPriceWithoutTax
  discount_price
  active_pricing {
    ... on CoursePrice {
      ...coursePriceFields
    }
  }
  rightIds
  trial_flag
  trial_date
  trialTerm
  trial_term_unit
  trialTermText
  trialText
  trialDate
  ref_id
  valuePlan
  questionId
  trialCampaignFlag
  contractAllowed
}
    ${CoursePriceFieldsFragmentDoc}`;export const ProductFieldsFragmentDoc=gql`
    fragment productFields on Product {
  id
  name
  thumbnailUrl
  description
  product_type
  sales_start_at
  sales_end_at
  price
  priceWithoutTax
  rightIds
  purchaseAllowed
}
    `;export const RightFieldsFragmentDoc=gql`
    fragment rightFields on Right {
  id
  name
  exercise_term
  exercise_term_unit
  view_term
  view_term_unit
  view_limit_date
  validity_start_at
  validity_end_at
  price
  discount_price
  isSvod
  package_type
  discount_description
  contractAllowed
}
    `;export const RecommendArticleFieldsFragmentDoc=gql`
    fragment recommendArticleFields on RecommendArticle {
  courses {
    ... on Course {
      ...courseFields
    }
  }
  products {
    ... on Product {
      ...productFields
      right {
        ... on Right {
          ...rightFields
        }
      }
    }
  }
}
    ${CourseFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${RightFieldsFragmentDoc}`;export const SubscriptionFieldsFragmentDoc=gql`
    fragment subscriptionFields on Subscription {
  subscription_id
  course_id
  payment_method_id
  payment_instrument_id
  initialTransactionAt
  nextTransactionAt
  status
  course {
    ... on Course {
      ...courseFields
    }
  }
  payment_instrument {
    values {
      card_number
      card_type
    }
  }
  withdraw_at
  trialStartAt
  trialEndAt
  entitlements {
    right_id
  }
  suspend_flag
}
    ${CourseFieldsFragmentDoc}`;export const VoucherFildsFragmentDoc=gql`
    fragment voucherFilds on Voucher {
  id
  name
  description
  discountPrice
  limitPrice
  trialExtendTerm
  trialExtendTermUnit
  trialExtendEndOf
  validityStartAt
  validityEndAt
}
    `;export const VoucherCodeFieldsFragmentDoc=gql`
    fragment voucherCodeFields on VoucherCode {
  id
  code
  voucherId
  validityStartAt
  validityEndAt
  expire_at
  isAvailable
  voucher {
    ...voucherFilds
  }
}
    ${VoucherFildsFragmentDoc}`;export const EstimateFieldsFragmentDoc=gql`
    fragment estimateFields on SubscriptionEstimate {
  subscription {
    ...subscriptionFields
  }
  voucherCode {
    ...voucherCodeFields
  }
  coursePricings {
    ...coursePriceFields
  }
  paymentPrice {
    ...coursePriceFields
  }
  campaignPrice {
    ...coursePriceFields
  }
  error
}
    ${SubscriptionFieldsFragmentDoc}
${VoucherCodeFieldsFragmentDoc}
${CoursePriceFieldsFragmentDoc}`;export const TermsFieldsFragmentDoc=gql`
    fragment termsFields on Term {
  id_key
  display_name
  required
  current_revision {
    unique_key
    number
    url
    agreement {
      agreement_id
      user_id
      term_id
      term_revision_number
    }
  }
}
    `;export const UserFavoritesFieldsFragmentDoc=gql`
    fragment userFavoritesFields on UserFavorites {
  id
  metas {
    ... on EpisodeMeta {
      id
    }
    ... on LiveMeta {
      id
    }
    ... on TVShowMeta {
      id
    }
    ... on ChannelMeta {
      id
    }
  }
}
    `;export const ProfileFieldsFragmentDoc=gql`
    fragment profileFields on ProfileUser {
  uuid
  id
  displayName: display_name
  birthday
  age
  sex
  ownerProfile
  needPasscode
  icon
  rating
}
    `;export const AccountFieldsFragmentDoc=gql`
    fragment accountFields on AccountUser {
  id
  uuid
  displayName: display_name
  birthday
  age
  sex
  mailAddress: mail_address
  firstName: first_name
  lastName: last_name
  fullName
  rightsFreeFlag: rights_free_flag
  currentProfile {
    ...profileFields
  }
  profiles {
    ...profileFields
  }
  test_flg
  hashedUserId
  receiveAdvertisingMailType
}
    ${ProfileFieldsFragmentDoc}`;export const AdvertisingDocument=gql`
    query Advertising($id: Int) {
  advertising(id: $id) {
    url
  }
}
    `;/**
 * __useAdvertisingQuery__
 *
 * To run a query within a React component, call `useAdvertisingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertisingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertisingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */export function useAdvertisingQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(AdvertisingDocument,options);}export function useAdvertisingLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(AdvertisingDocument,options);}export const AppInitDocument=gql`
    query AppInit {
  deviceInfo {
    ...deviceInfoFields
  }
  user {
    ...accountFields
  }
  favorites: userFavorites {
    ...userFavoritesFields
  }
}
    ${DeviceInfoFieldsFragmentDoc}
${AccountFieldsFragmentDoc}
${UserFavoritesFieldsFragmentDoc}`;/**
 * __useAppInitQuery__
 *
 * To run a query within a React component, call `useAppInitQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInitQuery({
 *   variables: {
 *   },
 * });
 */export function useAppInitQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(AppInitDocument,options);}export function useAppInitLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(AppInitDocument,options);}export const GenreAttributesDocument=gql`
    query GenreAttributes($ids: [Int]) {
  genreAttributes(ids: $ids) {
    attributes {
      name
      id
    }
  }
}
    `;/**
 * __useGenreAttributesQuery__
 *
 * To run a query within a React component, call `useGenreAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenreAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenreAttributesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */export function useGenreAttributesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(GenreAttributesDocument,options);}export function useGenreAttributesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(GenreAttributesDocument,options);}export const CanvasDocument=gql`
    query canvas($idKey: String, $offset: Int, $limit: Int, $withMeta: Boolean = false) {
  canvas(idKey: $idKey, offset: $offset, limit: $limit) {
    data {
      type
      id
    }
    meta @include(if: $withMeta) {
      title
      robots
      keywords
      description
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;/**
 * __useCanvasQuery__
 *
 * To run a query within a React component, call `useCanvasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvasQuery({
 *   variables: {
 *      idKey: // value for 'idKey'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      withMeta: // value for 'withMeta'
 *   },
 * });
 */export function useCanvasQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(CanvasDocument,options);}export function useCanvasLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(CanvasDocument,options);}export const ChannelsWithContractStatusDocument=gql`
    query ChannelsWithContractStatus($offset: Int, $limit: Int, $filter: JSONObject, $sort: String, $uuid: String) {
  channelsWithContractStatus(
    offset: $offset
    limit: $limit
    filter: $filter
    sort: $sort
    uuid: $uuid
  ) {
    data {
      ... on ChannelMeta {
        ...channelMetaFields
      }
      contractStatus
      contractAllowed
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${ChannelMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useChannelsWithContractStatusQuery__
 *
 * To run a query within a React component, call `useChannelsWithContractStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsWithContractStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsWithContractStatusQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */export function useChannelsWithContractStatusQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChannelsWithContractStatusDocument,options);}export function useChannelsWithContractStatusLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChannelsWithContractStatusDocument,options);}export const ChannelFeatureEpisodesDocument=gql`
    query ChannelFeatureEpisodes($id: Int, $offset: Int, $limit: Int) {
  channelFeatureEpisodes(id: $id, offset: $offset, limit: $limit) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useChannelFeatureEpisodesQuery__
 *
 * To run a query within a React component, call `useChannelFeatureEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelFeatureEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelFeatureEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function useChannelFeatureEpisodesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChannelFeatureEpisodesDocument,options);}export function useChannelFeatureEpisodesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChannelFeatureEpisodesDocument,options);}export const ChannelDetailDocument=gql`
    query ChannelDetail($id: Int, $withTabMenu: Boolean = false, $withEntitlement: Boolean = false) {
  channel: channelDetail(id: $id) {
    ... on ChannelMeta {
      ...channelMetaFields
    }
    contractAllowed
    tabMenu @include(if: $withTabMenu) {
      id
      title
      url
      values
    }
  }
  entitlements(metaId: $id) @include(if: $withEntitlement) {
    ...entitlementFields
  }
  course: courseByMetaId(metaId: $id) @include(if: $withEntitlement) {
    ...courseFields
  }
}
    ${ChannelMetaFieldsFragmentDoc}
${EntitlementFieldsFragmentDoc}
${CourseFieldsFragmentDoc}`;/**
 * __useChannelDetailQuery__
 *
 * To run a query within a React component, call `useChannelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTabMenu: // value for 'withTabMenu'
 *      withEntitlement: // value for 'withEntitlement'
 *   },
 * });
 */export function useChannelDetailQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChannelDetailDocument,options);}export function useChannelDetailLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChannelDetailDocument,options);}export const ChannelEpisodeSearchDocument=gql`
    query ChannelEpisodeSearch($keyword: String, $id: Int, $episodeType: EpisodeType, $offset: Int, $limit: Int) {
  channelEpisodeSearch(
    keyword: $keyword
    id: $id
    episodeType: $episodeType
    offset: $offset
    limit: $limit
  ) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useChannelEpisodeSearchQuery__
 *
 * To run a query within a React component, call `useChannelEpisodeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelEpisodeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelEpisodeSearchQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      id: // value for 'id'
 *      episodeType: // value for 'episodeType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function useChannelEpisodeSearchQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChannelEpisodeSearchDocument,options);}export function useChannelEpisodeSearchLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChannelEpisodeSearchDocument,options);}export const ChannelLiveScheduleDocument=gql`
    query ChannelLiveSchedule($id: Int, $day: String, $offset: Int, $limit: Int) {
  channelLiveSchedule(id: $id, day: $day, offset: $offset, limit: $limit) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useChannelLiveScheduleQuery__
 *
 * To run a query within a React component, call `useChannelLiveScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLiveScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLiveScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      day: // value for 'day'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function useChannelLiveScheduleQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChannelLiveScheduleDocument,options);}export function useChannelLiveScheduleLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChannelLiveScheduleDocument,options);}export const ChannelLinearEpisodesDocument=gql`
    query ChannelLinearEpisodes($id: Int, $offset: Int, $limit: Int, $filter: JSONObject) {
  channelLinearEpisodes(id: $id, offset: $offset, limit: $limit, filter: $filter) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useChannelLinearEpisodesQuery__
 *
 * To run a query within a React component, call `useChannelLinearEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLinearEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLinearEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */export function useChannelLinearEpisodesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChannelLinearEpisodesDocument,options);}export function useChannelLinearEpisodesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChannelLinearEpisodesDocument,options);}export const ChatGetAgreementDocument=gql`
    query ChatGetAgreement {
  getChatGuideLineAgreement {
    agreement
  }
}
    `;/**
 * __useChatGetAgreementQuery__
 *
 * To run a query within a React component, call `useChatGetAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetAgreementQuery({
 *   variables: {
 *   },
 * });
 */export function useChatGetAgreementQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChatGetAgreementDocument,options);}export function useChatGetAgreementLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChatGetAgreementDocument,options);}export const ChatSetAgreementDocument=gql`
    mutation ChatSetAgreement {
  setChatGuideLineAgreement {
    agreement
  }
}
    `;/**
 * __useChatSetAgreementMutation__
 *
 * To run a mutation, you first call `useChatSetAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatSetAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatSetAgreementMutation, { data, loading, error }] = useChatSetAgreementMutation({
 *   variables: {
 *   },
 * });
 */export function useChatSetAgreementMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(ChatSetAgreementDocument,options);}export const ChatGetRoomsDocument=gql`
    query ChatGetRooms($metaId: Int) {
  getRooms(metaId: $metaId) {
    totalCount
    rooms {
      ...roomFields
    }
  }
}
    ${RoomFieldsFragmentDoc}`;/**
 * __useChatGetRoomsQuery__
 *
 * To run a query within a React component, call `useChatGetRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetRoomsQuery({
 *   variables: {
 *      metaId: // value for 'metaId'
 *   },
 * });
 */export function useChatGetRoomsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChatGetRoomsDocument,options);}export function useChatGetRoomsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChatGetRoomsDocument,options);}export const ChatGetRoomTokenDocument=gql`
    query ChatGetRoomToken($roomId: String) {
  getRoomToken(roomId: $roomId) {
    token
  }
}
    `;/**
 * __useChatGetRoomTokenQuery__
 *
 * To run a query within a React component, call `useChatGetRoomTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetRoomTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetRoomTokenQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */export function useChatGetRoomTokenQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChatGetRoomTokenDocument,options);}export function useChatGetRoomTokenLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChatGetRoomTokenDocument,options);}export const ChatCreateUserDocument=gql`
    mutation ChatCreateUser($roomId: String, $metaId: Int) {
  createUser(roomId: $roomId, metaId: $metaId) {
    roomId
    refId
    id
  }
}
    `;/**
 * __useChatCreateUserMutation__
 *
 * To run a mutation, you first call `useChatCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatCreateUserMutation, { data, loading, error }] = useChatCreateUserMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      metaId: // value for 'metaId'
 *   },
 * });
 */export function useChatCreateUserMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(ChatCreateUserDocument,options);}export const ChatGetUserTokenDocument=gql`
    query ChatGetUserToken($roomId: String, $userId: String) {
  getUserToken(roomId: $roomId, userId: $userId) {
    token
  }
}
    `;/**
 * __useChatGetUserTokenQuery__
 *
 * To run a query within a React component, call `useChatGetUserTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetUserTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetUserTokenQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      userId: // value for 'userId'
 *   },
 * });
 */export function useChatGetUserTokenQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ChatGetUserTokenDocument,options);}export function useChatGetUserTokenLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ChatGetUserTokenDocument,options);}export const ChatPostMessageDocument=gql`
    mutation ChatPostMessage($roomId: String, $userId: String, $message: String, $refId: String, $displayName: String, $token: String) {
  postChatMessage(
    roomId: $roomId
    userId: $userId
    message: $message
    refId: $refId
    displayName: $displayName
    token: $token
  ) {
    message
    sender {
      ...senderFields
    }
    roomId
    isNGMessage
    id
  }
}
    ${SenderFieldsFragmentDoc}`;/**
 * __useChatPostMessageMutation__
 *
 * To run a mutation, you first call `useChatPostMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatPostMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatPostMessageMutation, { data, loading, error }] = useChatPostMessageMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      userId: // value for 'userId'
 *      message: // value for 'message'
 *      refId: // value for 'refId'
 *      displayName: // value for 'displayName'
 *      token: // value for 'token'
 *   },
 * });
 */export function useChatPostMessageMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(ChatPostMessageDocument,options);}export const ChatDeleteMessageDocument=gql`
    mutation ChatDeleteMessage($roomId: String, $messageId: String) {
  deleteChatMessage(roomId: $roomId, messageId: $messageId) {
    result
  }
}
    `;/**
 * __useChatDeleteMessageMutation__
 *
 * To run a mutation, you first call `useChatDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatDeleteMessageMutation, { data, loading, error }] = useChatDeleteMessageMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */export function useChatDeleteMessageMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(ChatDeleteMessageDocument,options);}export const ChatReportMessageDocument=gql`
    mutation ChatReportMessage($roomId: String, $messageId: String, $reason: String) {
  reportChatMessage(roomId: $roomId, messageId: $messageId, reason: $reason) {
    result
  }
}
    `;/**
 * __useChatReportMessageMutation__
 *
 * To run a mutation, you first call `useChatReportMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatReportMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatReportMessageMutation, { data, loading, error }] = useChatReportMessageMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      messageId: // value for 'messageId'
 *      reason: // value for 'reason'
 *   },
 * });
 */export function useChatReportMessageMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(ChatReportMessageDocument,options);}export const TvShowEpisodesDocument=gql`
    query TvShowEpisodes($id: Int, $offset: Int, $limit: Int, $filter: JSONObject, $sort: JSONObject) {
  children(id: $id, offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    data {
      ...episodeMetaFields
      ...liveMetaFields
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useTvShowEpisodesQuery__
 *
 * To run a query within a React component, call `useTvShowEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTvShowEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTvShowEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */export function useTvShowEpisodesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(TvShowEpisodesDocument,options);}export function useTvShowEpisodesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(TvShowEpisodesDocument,options);}export const CourseByRightIdDocument=gql`
    query CourseByRightId($rightId: Int) {
  courseByRightId(rightId: $rightId) {
    ...courseFields
  }
}
    ${CourseFieldsFragmentDoc}`;/**
 * __useCourseByRightIdQuery__
 *
 * To run a query within a React component, call `useCourseByRightIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByRightIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByRightIdQuery({
 *   variables: {
 *      rightId: // value for 'rightId'
 *   },
 * });
 */export function useCourseByRightIdQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(CourseByRightIdDocument,options);}export function useCourseByRightIdLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(CourseByRightIdDocument,options);}export const CourseByIdDocument=gql`
    query CourseById($courseId: Int) {
  course: courseById(courseId: $courseId) {
    ... on Course {
      ...courseFields
    }
  }
}
    ${CourseFieldsFragmentDoc}`;/**
 * __useCourseByIdQuery__
 *
 * To run a query within a React component, call `useCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */export function useCourseByIdQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(CourseByIdDocument,options);}export function useCourseByIdLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(CourseByIdDocument,options);}export const DeviceInfoDocument=gql`
    query DeviceInfo {
  deviceInfo {
    ...deviceInfoFields
  }
}
    ${DeviceInfoFieldsFragmentDoc}`;/**
 * __useDeviceInfoQuery__
 *
 * To run a query within a React component, call `useDeviceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceInfoQuery({
 *   variables: {
 *   },
 * });
 */export function useDeviceInfoQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(DeviceInfoDocument,options);}export function useDeviceInfoLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(DeviceInfoDocument,options);}export const GetEntitledStoreEpisodesDocument=gql`
    query GetEntitledStoreEpisodes($offset: Int, $limit: Int) {
  getEntitledStoreEpisodes(offset: $offset, limit: $limit) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useGetEntitledStoreEpisodesQuery__
 *
 * To run a query within a React component, call `useGetEntitledStoreEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitledStoreEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitledStoreEpisodesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function useGetEntitledStoreEpisodesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(GetEntitledStoreEpisodesDocument,options);}export function useGetEntitledStoreEpisodesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(GetEntitledStoreEpisodesDocument,options);}export const GenrePaletteEpisodesDocument=gql`
    query GenrePaletteEpisodes($channel: Int, $genre: [Int], $offset: Int, $limit: Int, $sortOrder: String, $type: String) {
  genrePaletteEpisodes(
    channel: $channel
    genre: $genre
    offset: $offset
    limit: $limit
    sortOrder: $sortOrder
    type: $type
  ) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useGenrePaletteEpisodesQuery__
 *
 * To run a query within a React component, call `useGenrePaletteEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenrePaletteEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenrePaletteEpisodesQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      genre: // value for 'genre'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      type: // value for 'type'
 *   },
 * });
 */export function useGenrePaletteEpisodesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(GenrePaletteEpisodesDocument,options);}export function useGenrePaletteEpisodesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(GenrePaletteEpisodesDocument,options);}export const EntitledDocument=gql`
    query Entitled($channelId: Int, $contentType: String, $offset: Int, $limit: Int) {
  entitled(
    channelId: $channelId
    contentType: $contentType
    offset: $offset
    limit: $limit
  ) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
      ... on TVShowMeta {
        ...tvShowMetaFields
      }
      ... on ChannelMeta {
        ...channelMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${ChannelMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useEntitledQuery__
 *
 * To run a query within a React component, call `useEntitledQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitledQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      contentType: // value for 'contentType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function useEntitledQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(EntitledDocument,options);}export function useEntitledLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(EntitledDocument,options);}export const HtmlSnippetDocument=gql`
    query HtmlSnippet($id: Int, $idKey: String) {
  htmlSnippet(id: $id, idKey: $idKey) {
    id
    content
    style
    javascript
  }
}
    `;/**
 * __useHtmlSnippetQuery__
 *
 * To run a query within a React component, call `useHtmlSnippetQuery` and pass it any options that fit your needs.
 * When your component renders, `useHtmlSnippetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHtmlSnippetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      idKey: // value for 'idKey'
 *   },
 * });
 */export function useHtmlSnippetQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(HtmlSnippetDocument,options);}export function useHtmlSnippetLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(HtmlSnippetDocument,options);}export const IdcTokenEndPointDocument=gql`
    mutation IdcTokenEndPoint($code: String, $redirectUri: String) {
  idcTokenEndPoint(code: $code, redirectUri: $redirectUri) {
    access_token
    expires_in
    refresh_token
    scope
    error
    error_description
    interval
  }
}
    `;/**
 * __useIdcTokenEndPointMutation__
 *
 * To run a mutation, you first call `useIdcTokenEndPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdcTokenEndPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [idcTokenEndPointMutation, { data, loading, error }] = useIdcTokenEndPointMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */export function useIdcTokenEndPointMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(IdcTokenEndPointDocument,options);}export const IdcUserInfoEndPointDocument=gql`
    query IdcUserInfoEndPoint {
  idcUserInfoEndPoint {
    sub
    iss
    aud
    email
    name
    namekana
    gender
    birthdate
  }
}
    `;/**
 * __useIdcUserInfoEndPointQuery__
 *
 * To run a query within a React component, call `useIdcUserInfoEndPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdcUserInfoEndPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdcUserInfoEndPointQuery({
 *   variables: {
 *   },
 * });
 */export function useIdcUserInfoEndPointQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(IdcUserInfoEndPointDocument,options);}export function useIdcUserInfoEndPointLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(IdcUserInfoEndPointDocument,options);}export const IdcUserInfoEndPointAgeValidateDocument=gql`
    query IdcUserInfoEndPointAgeValidate {
  idcUserInfoEndPointAgeValidate {
    sub
    iss
    aud
    email
    name
    namekana
    gender
    birthdate
  }
}
    `;/**
 * __useIdcUserInfoEndPointAgeValidateQuery__
 *
 * To run a query within a React component, call `useIdcUserInfoEndPointAgeValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdcUserInfoEndPointAgeValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdcUserInfoEndPointAgeValidateQuery({
 *   variables: {
 *   },
 * });
 */export function useIdcUserInfoEndPointAgeValidateQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(IdcUserInfoEndPointAgeValidateDocument,options);}export function useIdcUserInfoEndPointAgeValidateLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(IdcUserInfoEndPointAgeValidateDocument,options);}export const IdcTokenVerifyEndPointDocument=gql`
    query IdcTokenVerifyEndPoint {
  idcTokenVerifyEndPoint {
    access_token
    token_type
    expires_in
    user_id
    elipsis_flg
    client_id
  }
}
    `;/**
 * __useIdcTokenVerifyEndPointQuery__
 *
 * To run a query within a React component, call `useIdcTokenVerifyEndPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdcTokenVerifyEndPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdcTokenVerifyEndPointQuery({
 *   variables: {
 *   },
 * });
 */export function useIdcTokenVerifyEndPointQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(IdcTokenVerifyEndPointDocument,options);}export function useIdcTokenVerifyEndPointLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(IdcTokenVerifyEndPointDocument,options);}export const InformationsDocument=gql`
    query Informations($key: String, $offset: Int, $limit: Int) {
  informations(key: $key, offset: $offset, limit: $limit) {
    data {
      id
      title
      url
      targetBlank
      date
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;/**
 * __useInformationsQuery__
 *
 * To run a query within a React component, call `useInformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInformationsQuery({
 *   variables: {
 *      key: // value for 'key'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function useInformationsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(InformationsDocument,options);}export function useInformationsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(InformationsDocument,options);}export const InquiryDocument=gql`
    mutation Inquiry($name: String!, $mailAddress: String!, $subject: String!, $body: String!, $comment: String!) {
  sendInquiryMail(
    name: $name
    mailAddress: $mailAddress
    subject: $subject
    body: $body
    comment: $comment
  ) {
    result
  }
}
    `;/**
 * __useInquiryMutation__
 *
 * To run a mutation, you first call `useInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inquiryMutation, { data, loading, error }] = useInquiryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      mailAddress: // value for 'mailAddress'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      comment: // value for 'comment'
 *   },
 * });
 */export function useInquiryMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(InquiryDocument,options);}export const ProductOrdersDocument=gql`
    query ProductOrders($with_order: Boolean, $with_payment_instrument: Boolean, $with_entitlements: Boolean, $type: String) {
  productOrders(
    with_order: $with_order
    with_payment_instrument: $with_payment_instrument
    with_entitlements: $with_entitlements
    type: $type
  ) {
    data {
      name
      order_id
      created_at
      order {
        finished_at
        payment_amount
        payment_instrument {
          payment_method_id
          values {
            card_type
            card_number
          }
        }
      }
      entitlements {
        end_at
        right_id
      }
    }
  }
}
    `;/**
 * __useProductOrdersQuery__
 *
 * To run a query within a React component, call `useProductOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOrdersQuery({
 *   variables: {
 *      with_order: // value for 'with_order'
 *      with_payment_instrument: // value for 'with_payment_instrument'
 *      with_entitlements: // value for 'with_entitlements'
 *      type: // value for 'type'
 *   },
 * });
 */export function useProductOrdersQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ProductOrdersDocument,options);}export function useProductOrdersLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ProductOrdersDocument,options);}export const OrdersDocument=gql`
    query Orders($offset: Int, $limit: Int, $year: Int) {
  orders(offset: $offset, limit: $limit, year: $year) {
    data {
      name
      created_at
      payment_amount
      order_type
      payment_instrument {
        payment_method_id
        values {
          card_type
          card_number
        }
      }
      values {
        product_price
        discount_name
        transaction_start_at
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      year: // value for 'year'
 *   },
 * });
 */export function useOrdersQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(OrdersDocument,options);}export function useOrdersLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(OrdersDocument,options);}export const PaletteDocument=gql`
    query Palette($id: Int, $offset: Int, $limit: Int) {
  palette(id: $id) {
    palette_id
    name
    id_key
    header
    description
    schema_id
    schema
    values
  }
  paletteObjects(id: $id, offset: $offset, limit: $limit) {
    data {
      id
      type
      meta {
        ... on EpisodeMeta {
          ...episodeMetaFields
        }
        ... on LiveMeta {
          ...liveMetaFields
        }
        ... on TVShowMeta {
          ...tvShowMetaFields
        }
        ... on ChannelMeta {
          ...channelMetaFields
        }
      }
      advertising {
        ...advertisingFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${ChannelMetaFieldsFragmentDoc}
${AdvertisingFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __usePaletteQuery__
 *
 * To run a query within a React component, call `usePaletteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaletteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaletteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function usePaletteQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(PaletteDocument,options);}export function usePaletteLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(PaletteDocument,options);}export const PaletteObjectsDocument=gql`
    query PaletteObjects($id: Int, $offset: Int, $limit: Int) {
  paletteObjects(id: $id, offset: $offset, limit: $limit) {
    data {
      id
      type
      meta {
        ... on EpisodeMeta {
          ...episodeMetaFields
        }
        ... on LiveMeta {
          ...liveMetaFields
        }
        ... on TVShowMeta {
          ...tvShowMetaFields
        }
        ... on ChannelMeta {
          ...channelMetaFields
        }
      }
      advertising {
        ...advertisingFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${ChannelMetaFieldsFragmentDoc}
${AdvertisingFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __usePaletteObjectsQuery__
 *
 * To run a query within a React component, call `usePaletteObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaletteObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaletteObjectsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function usePaletteObjectsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(PaletteObjectsDocument,options);}export function usePaletteObjectsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(PaletteObjectsDocument,options);}export const PaymentInstrumentsDocument=gql`
    query PaymentInstruments($type: String, $scope: String) {
  paymentInstruments(type: $type, scope: $scope) {
    default_flag
    payment_method {
      name
    }
    payment_method_id
    payment_instrument_id
    ref_id
    values {
      card_number
      card_type
      expiry_date
    }
  }
}
    `;/**
 * __usePaymentInstrumentsQuery__
 *
 * To run a query within a React component, call `usePaymentInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInstrumentsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      scope: // value for 'scope'
 *   },
 * });
 */export function usePaymentInstrumentsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(PaymentInstrumentsDocument,options);}export function usePaymentInstrumentsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(PaymentInstrumentsDocument,options);}export const PaymentInstrumentInfoDocument=gql`
    query PaymentInstrumentInfo($id: Int) {
  paymentInstrumentInfo(id: $id) {
    default_flag
    payment_method {
      name
    }
    payment_method_id
    payment_instrument_id
    ref_id
    values {
      card_number
      card_type
      expiry_date
    }
  }
}
    `;/**
 * __usePaymentInstrumentInfoQuery__
 *
 * To run a query within a React component, call `usePaymentInstrumentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInstrumentInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */export function usePaymentInstrumentInfoQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(PaymentInstrumentInfoDocument,options);}export function usePaymentInstrumentInfoLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(PaymentInstrumentInfoDocument,options);}export const PaymentInstrumentsCreateCreditCardRecaptchaV2Document=gql`
    mutation PaymentInstrumentsCreateCreditCardRecaptchaV2($payment_method_id: Int, $replace_flag: Boolean, $success_url: String, $cancel_url: String, $error_url: String, $token: String, $token_key: String, $tds_info_token: String, $tds_info_token_key: String, $tokenPayload: JSONObject, $recaptchaTokenV2: String) {
  paymentInstrumentsCreateCreditCardRecaptchaV2(
    payment_method_id: $payment_method_id
    replace_flag: $replace_flag
    success_url: $success_url
    cancel_url: $cancel_url
    error_url: $error_url
    token: $token
    token_key: $token_key
    tds_info_token: $tds_info_token
    tds_info_token_key: $tds_info_token_key
    tokenPayload: $tokenPayload
    recaptchaTokenV2: $recaptchaTokenV2
  ) {
    redirect_link
    http_method
    redirect_url
    charset
    form_data {
      pay_method
      merchant_id
      service_id
      cust_code
      order_id
      item_id
      item_name
      service_type
      terminal_type
      success_url
      cancel_url
      error_url
      pagecon_url
      free1
      free2
      free3
      request_date
      limit_second
      sps_hashcode
    }
    error
    recaptchaSuccessV2
  }
}
    `;/**
 * __usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateCreditCardRecaptchaV2Mutation, { data, loading, error }] = usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      success_url: // value for 'success_url'
 *      cancel_url: // value for 'cancel_url'
 *      error_url: // value for 'error_url'
 *      token: // value for 'token'
 *      token_key: // value for 'token_key'
 *      tds_info_token: // value for 'tds_info_token'
 *      tds_info_token_key: // value for 'tds_info_token_key'
 *      tokenPayload: // value for 'tokenPayload'
 *      recaptchaTokenV2: // value for 'recaptchaTokenV2'
 *   },
 * });
 */export function usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PaymentInstrumentsCreateCreditCardRecaptchaV2Document,options);}export const PaymentInstrumentsCreateCreditCardRecaptchaV3Document=gql`
    mutation PaymentInstrumentsCreateCreditCardRecaptchaV3($payment_method_id: Int, $replace_flag: Boolean, $success_url: String, $cancel_url: String, $error_url: String, $token: String, $token_key: String, $tds_info_token: String, $tds_info_token_key: String, $tokenPayload: JSONObject, $recaptchaTokenV3: String) {
  paymentInstrumentsCreateCreditCardRecaptchaV3(
    payment_method_id: $payment_method_id
    replace_flag: $replace_flag
    success_url: $success_url
    cancel_url: $cancel_url
    error_url: $error_url
    token: $token
    token_key: $token_key
    tds_info_token: $tds_info_token
    tds_info_token_key: $tds_info_token_key
    tokenPayload: $tokenPayload
    recaptchaTokenV3: $recaptchaTokenV3
  ) {
    redirect_link
    http_method
    redirect_url
    charset
    form_data {
      pay_method
      merchant_id
      service_id
      cust_code
      order_id
      item_id
      item_name
      service_type
      terminal_type
      success_url
      cancel_url
      error_url
      pagecon_url
      free1
      free2
      free3
      request_date
      limit_second
      sps_hashcode
    }
    error
    recaptchaSuccessV3
  }
}
    `;/**
 * __usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateCreditCardRecaptchaV3Mutation, { data, loading, error }] = usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      success_url: // value for 'success_url'
 *      cancel_url: // value for 'cancel_url'
 *      error_url: // value for 'error_url'
 *      token: // value for 'token'
 *      token_key: // value for 'token_key'
 *      tds_info_token: // value for 'tds_info_token'
 *      tds_info_token_key: // value for 'tds_info_token_key'
 *      tokenPayload: // value for 'tokenPayload'
 *      recaptchaTokenV3: // value for 'recaptchaTokenV3'
 *   },
 * });
 */export function usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PaymentInstrumentsCreateCreditCardRecaptchaV3Document,options);}export const PaymentInstrumentsCreateOtherDocument=gql`
    mutation PaymentInstrumentsCreateOther($payment_method_id: Int, $replace_flag: Boolean, $success_url: String, $cancel_url: String, $error_url: String, $tokenPayload: JSONObject) {
  paymentInstrumentsCreateOther(
    payment_method_id: $payment_method_id
    replace_flag: $replace_flag
    success_url: $success_url
    cancel_url: $cancel_url
    error_url: $error_url
    tokenPayload: $tokenPayload
  ) {
    redirect_link
    http_method
    redirect_url
    charset
    form_data {
      pay_method
      merchant_id
      service_id
      cust_code
      order_id
      item_id
      item_name
      service_type
      terminal_type
      success_url
      cancel_url
      error_url
      pagecon_url
      free1
      free2
      free3
      request_date
      limit_second
      sps_hashcode
    }
    error
  }
}
    `;/**
 * __usePaymentInstrumentsCreateOtherMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateOtherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateOtherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateOtherMutation, { data, loading, error }] = usePaymentInstrumentsCreateOtherMutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      success_url: // value for 'success_url'
 *      cancel_url: // value for 'cancel_url'
 *      error_url: // value for 'error_url'
 *      tokenPayload: // value for 'tokenPayload'
 *   },
 * });
 */export function usePaymentInstrumentsCreateOtherMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PaymentInstrumentsCreateOtherDocument,options);}export const PaymentInstrumentsActivateDocument=gql`
    mutation PaymentInstrumentsActivate($payment_instrument_id: Int) {
  paymentInstrumentsActivate(payment_instrument_id: $payment_instrument_id) {
    payment_instrument_id
    error {
      message
    }
  }
}
    `;/**
 * __usePaymentInstrumentsActivateMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsActivateMutation, { data, loading, error }] = usePaymentInstrumentsActivateMutation({
 *   variables: {
 *      payment_instrument_id: // value for 'payment_instrument_id'
 *   },
 * });
 */export function usePaymentInstrumentsActivateMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PaymentInstrumentsActivateDocument,options);}export const PaymentInstrumentsDeactivateDocument=gql`
    mutation PaymentInstrumentsDeactivate($payment_instrument_id: Int) {
  paymentInstrumentsDeactivate(payment_instrument_id: $payment_instrument_id) {
    payment_instrument_id
    error {
      message
    }
  }
}
    `;/**
 * __usePaymentInstrumentsDeactivateMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsDeactivateMutation, { data, loading, error }] = usePaymentInstrumentsDeactivateMutation({
 *   variables: {
 *      payment_instrument_id: // value for 'payment_instrument_id'
 *   },
 * });
 */export function usePaymentInstrumentsDeactivateMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PaymentInstrumentsDeactivateDocument,options);}export const PaymentInstrumentsSetDefaultDocument=gql`
    mutation PaymentInstrumentsSetDefault($payment_instrument_id: Int) {
  paymentInstrumentsSetDefault(payment_instrument_id: $payment_instrument_id) {
    result
  }
}
    `;/**
 * __usePaymentInstrumentsSetDefaultMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsSetDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsSetDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsSetDefaultMutation, { data, loading, error }] = usePaymentInstrumentsSetDefaultMutation({
 *   variables: {
 *      payment_instrument_id: // value for 'payment_instrument_id'
 *   },
 * });
 */export function usePaymentInstrumentsSetDefaultMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PaymentInstrumentsSetDefaultDocument,options);}export const AddPaymentInstrumentSendMailDocument=gql`
    mutation AddPaymentInstrumentSendMail($paymentInstrumentId: Int) {
  addPaymentInstrumentSendMail(paymentInstrumentId: $paymentInstrumentId) {
    result
  }
}
    `;/**
 * __useAddPaymentInstrumentSendMailMutation__
 *
 * To run a mutation, you first call `useAddPaymentInstrumentSendMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentInstrumentSendMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentInstrumentSendMailMutation, { data, loading, error }] = useAddPaymentInstrumentSendMailMutation({
 *   variables: {
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *   },
 * });
 */export function useAddPaymentInstrumentSendMailMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AddPaymentInstrumentSendMailDocument,options);}export const PaymentMethodsDocument=gql`
    query PaymentMethods {
  paymentMethods {
    name
    payment_method_id
    payment_method_type_name
  }
  paymentInstruments {
    default_flag
    payment_method {
      name
    }
    payment_method_id
    payment_instrument_id
    ref_id
    values {
      card_number
      card_type
      expiry_date
    }
  }
}
    `;/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */export function usePaymentMethodsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(PaymentMethodsDocument,options);}export function usePaymentMethodsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(PaymentMethodsDocument,options);}export const PinActivateDocument=gql`
    mutation PinActivate($code: String) {
  pinActivate(code: $code) {
    status
    result
    deviceToken
  }
}
    `;/**
 * __usePinActivateMutation__
 *
 * To run a mutation, you first call `usePinActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinActivateMutation, { data, loading, error }] = usePinActivateMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */export function usePinActivateMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PinActivateDocument,options);}export const PlaybackAuthDocument=gql`
    query PlaybackAuth($id: Int, $vuid: String, $sessionId: String, $fl: Int) {
  playbackAuth(id: $id, vuid: $vuid, sessionId: $sessionId, fl: $fl) {
    media {
      media_id
      uuid
      ovp_id
      ovp_video_id
      thumbnail_tile_urls
    }
    rule {
      playback_rule_id
      enable_seek_flag
      enable_cromecst_flag
      enable_airplay_flag
      enable_mirroring_flag
      enable_external_monitor_flag
      enable_catchup_flag
      enable_start_over_flag
      enable_pause_flag
      enable_background_play_flag
      enable_screen_capture_flag
      enable_playback_rate_change_flag
      enable_offline_play_flag
      maximum_bitrate
      minimum_bitrate
    }
    playback_session_id
    log_params
    resumePoint
    error {
      type
      message
      code
    }
    entitlements {
      ...entitlementFields
    }
  }
}
    ${EntitlementFieldsFragmentDoc}`;/**
 * __usePlaybackAuthQuery__
 *
 * To run a query within a React component, call `usePlaybackAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybackAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybackAuthQuery({
 *   variables: {
 *      id: // value for 'id'
 *      vuid: // value for 'vuid'
 *      sessionId: // value for 'sessionId'
 *      fl: // value for 'fl'
 *   },
 * });
 */export function usePlaybackAuthQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(PlaybackAuthDocument,options);}export function usePlaybackAuthLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(PlaybackAuthDocument,options);}export const PlaybackSessionOpenDocument=gql`
    mutation PlaybackSessionOpen($videoId: String, $sessionId: String) {
  playbackSessionOpen(videoId: $videoId, sessionId: $sessionId) {
    media
    error {
      type
      message
      code
    }
  }
}
    `;/**
 * __usePlaybackSessionOpenMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionOpenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionOpenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionOpenMutation, { data, loading, error }] = usePlaybackSessionOpenMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */export function usePlaybackSessionOpenMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PlaybackSessionOpenDocument,options);}export const PlaybackSessionCheckDocument=gql`
    mutation PlaybackSessionCheck($sessionId: String) {
  playbackSessionCheck(sessionId: $sessionId) {
    result
  }
}
    `;/**
 * __usePlaybackSessionCheckMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionCheckMutation, { data, loading, error }] = usePlaybackSessionCheckMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */export function usePlaybackSessionCheckMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PlaybackSessionCheckDocument,options);}export const PlaybackSessionCloseDocument=gql`
    mutation PlaybackSessionClose($sessionId: String) {
  playbackSessionClose(sessionId: $sessionId) {
    result
  }
}
    `;/**
 * __usePlaybackSessionCloseMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionCloseMutation, { data, loading, error }] = usePlaybackSessionCloseMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */export function usePlaybackSessionCloseMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PlaybackSessionCloseDocument,options);}export const ProductByIdDocument=gql`
    query ProductById($id: Int) {
  product: productById(id: $id) {
    ...productFields
    purchased
    right {
      ... on Right {
        ...rightFields
      }
    }
    meta {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
  }
}
    ${ProductFieldsFragmentDoc}
${RightFieldsFragmentDoc}
${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}`;/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */export function useProductByIdQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ProductByIdDocument,options);}export function useProductByIdLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ProductByIdDocument,options);}export const PurchaseEstimateDocument=gql`
    query PurchaseEstimate($productId: Int, $paymentMethodId: Int) {
  estimate: purchaseEstimate(
    productId: $productId
    paymentMethodId: $paymentMethodId
  ) {
    product {
      ... on Product {
        ...productFields
        voucherCode {
          ... on VoucherCode {
            ...voucherCodeFields
          }
        }
      }
    }
    error
  }
}
    ${ProductFieldsFragmentDoc}
${VoucherCodeFieldsFragmentDoc}`;/**
 * __usePurchaseEstimateQuery__
 *
 * To run a query within a React component, call `usePurchaseEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseEstimateQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */export function usePurchaseEstimateQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(PurchaseEstimateDocument,options);}export function usePurchaseEstimateLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(PurchaseEstimateDocument,options);}export const PurchaseEstimateWithCouponDocument=gql`
    query PurchaseEstimateWithCoupon($productId: Int, $paymentMethodId: Int, $voucherCode: String) {
  estimateWithCoupon: purchaseEstimate(
    productId: $productId
    paymentMethodId: $paymentMethodId
    voucherCode: $voucherCode
  ) {
    product {
      ... on Product {
        ...productFields
        voucherCode {
          ... on VoucherCode {
            ...voucherCodeFields
          }
        }
        discountPrice
      }
    }
    error
  }
}
    ${ProductFieldsFragmentDoc}
${VoucherCodeFieldsFragmentDoc}`;/**
 * __usePurchaseEstimateWithCouponQuery__
 *
 * To run a query within a React component, call `usePurchaseEstimateWithCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseEstimateWithCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseEstimateWithCouponQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      voucherCode: // value for 'voucherCode'
 *   },
 * });
 */export function usePurchaseEstimateWithCouponQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(PurchaseEstimateWithCouponDocument,options);}export function usePurchaseEstimateWithCouponLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(PurchaseEstimateWithCouponDocument,options);}export const PurchaseExecuteDocument=gql`
    mutation PurchaseExecute($productId: Int, $paymentInstrumentId: Int, $voucherCode: String) {
  purchaseExecute(
    productId: $productId
    paymentInstrumentId: $paymentInstrumentId
    voucherCode: $voucherCode
  ) {
    product_order_id
    product_id
    status
    name
    created_at
    error
    order {
      order_id
      payment_method_id
      payment_amount
    }
  }
}
    `;/**
 * __usePurchaseExecuteMutation__
 *
 * To run a mutation, you first call `usePurchaseExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseExecuteMutation, { data, loading, error }] = usePurchaseExecuteMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      voucherCode: // value for 'voucherCode'
 *   },
 * });
 */export function usePurchaseExecuteMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PurchaseExecuteDocument,options);}export const PurchaseTestDocument=gql`
    mutation PurchaseTest($productId: Int, $paymentInstrumentId: Int, $voucherCode: String, $userVoucherId: Int, $mode: String) {
  purchaseTest(
    productId: $productId
    paymentInstrumentId: $paymentInstrumentId
    voucherCode: $voucherCode
    userVoucherId: $userVoucherId
    mode: $mode
  ) {
    product_order_id
    product_id
    status
    name
    created_at
    error
    order {
      order_id
      payment_method_id
      payment_amount
    }
  }
}
    `;/**
 * __usePurchaseTestMutation__
 *
 * To run a mutation, you first call `usePurchaseTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseTestMutation, { data, loading, error }] = usePurchaseTestMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      voucherCode: // value for 'voucherCode'
 *      userVoucherId: // value for 'userVoucherId'
 *      mode: // value for 'mode'
 *   },
 * });
 */export function usePurchaseTestMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(PurchaseTestDocument,options);}export const RankingDocument=gql`
    query ranking($target: String, $range: String, $channel: Int, $count: Int) {
  ranking(target: $target, range: $range, channel: $channel, count: $count) {
    id
    rank
    meta {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}`;/**
 * __useRankingQuery__
 *
 * To run a query within a React component, call `useRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankingQuery({
 *   variables: {
 *      target: // value for 'target'
 *      range: // value for 'range'
 *      channel: // value for 'channel'
 *      count: // value for 'count'
 *   },
 * });
 */export function useRankingQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(RankingDocument,options);}export function useRankingLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(RankingDocument,options);}export const RecommendArticleDocument=gql`
    query RecommendArticle {
  recommendArticle {
    ... on RecommendArticle {
      ...recommendArticleFields
    }
  }
}
    ${RecommendArticleFieldsFragmentDoc}`;/**
 * __useRecommendArticleQuery__
 *
 * To run a query within a React component, call `useRecommendArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendArticleQuery({
 *   variables: {
 *   },
 * });
 */export function useRecommendArticleQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(RecommendArticleDocument,options);}export function useRecommendArticleLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(RecommendArticleDocument,options);}export const UpdateRecommendArticleDocument=gql`
    mutation UpdateRecommendArticle($type: String!, $id: [Int]) {
  updateRecommendArticle(type: $type, id: $id) {
    ... on RecommendArticle {
      ...recommendArticleFields
    }
  }
}
    ${RecommendArticleFieldsFragmentDoc}`;/**
 * __useUpdateRecommendArticleMutation__
 *
 * To run a mutation, you first call `useUpdateRecommendArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecommendArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecommendArticleMutation, { data, loading, error }] = useUpdateRecommendArticleMutation({
 *   variables: {
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */export function useUpdateRecommendArticleMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(UpdateRecommendArticleDocument,options);}export const ClearRecommendArticleDocument=gql`
    mutation ClearRecommendArticle {
  clearRecommendArticle {
    ... on RecommendArticle {
      ...recommendArticleFields
    }
  }
}
    ${RecommendArticleFieldsFragmentDoc}`;/**
 * __useClearRecommendArticleMutation__
 *
 * To run a mutation, you first call `useClearRecommendArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRecommendArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRecommendArticleMutation, { data, loading, error }] = useClearRecommendArticleMutation({
 *   variables: {
 *   },
 * });
 */export function useClearRecommendArticleMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(ClearRecommendArticleDocument,options);}export const RtTrackDocument=gql`
    mutation RtTrack($location: String!, $referrer: String, $sid: String) {
  track(location: $location, referrer: $referrer, sid: $sid) {
    result
  }
}
    `;/**
 * __useRtTrackMutation__
 *
 * To run a mutation, you first call `useRtTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRtTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rtTrackMutation, { data, loading, error }] = useRtTrackMutation({
 *   variables: {
 *      location: // value for 'location'
 *      referrer: // value for 'referrer'
 *      sid: // value for 'sid'
 *   },
 * });
 */export function useRtTrackMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(RtTrackDocument,options);}export const RtRecommendDocument=gql`
    query RtRecommend($location: String!, $elementIds: [String!]) {
  recommend(location: $location, elementIds: $elementIds) {
    elementId
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
        rtsid
      }
      ... on LiveMeta {
        ...liveMetaFields
        rtsid
      }
      ... on TVShowMeta {
        ...tvShowMetaFields
        rtsid
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useRtRecommendQuery__
 *
 * To run a query within a React component, call `useRtRecommendQuery` and pass it any options that fit your needs.
 * When your component renders, `useRtRecommendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRtRecommendQuery({
 *   variables: {
 *      location: // value for 'location'
 *      elementIds: // value for 'elementIds'
 *   },
 * });
 */export function useRtRecommendQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(RtRecommendDocument,options);}export function useRtRecommendLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(RtRecommendDocument,options);}export const SearchEpisodeDocument=gql`
    query SearchEpisode($keyword: String, $filter: JSONObject, $sort: String, $offset: Int, $limit: Int, $minScore: Int) {
  search(
    keyword: $keyword
    filter: $filter
    sort: $sort
    offset: $offset
    limit: $limit
    minScore: $minScore
  ) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useSearchEpisodeQuery__
 *
 * To run a query within a React component, call `useSearchEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEpisodeQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      minScore: // value for 'minScore'
 *   },
 * });
 */export function useSearchEpisodeQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SearchEpisodeDocument,options);}export function useSearchEpisodeLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SearchEpisodeDocument,options);}export const SearchTvShowDocument=gql`
    query SearchTvShow($keyword: String, $filter: JSONObject, $sort: String, $offset: Int, $limit: Int, $minScore: Int) {
  search: searchTvShow(
    keyword: $keyword
    filter: $filter
    sort: $sort
    offset: $offset
    limit: $limit
    minScore: $minScore
  ) {
    data {
      ... on TVShowMeta {
        ...tvShowMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${TvShowMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useSearchTvShowQuery__
 *
 * To run a query within a React component, call `useSearchTvShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTvShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTvShowQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      minScore: // value for 'minScore'
 *   },
 * });
 */export function useSearchTvShowQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SearchTvShowDocument,options);}export function useSearchTvShowLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SearchTvShowDocument,options);}export const SearchConfigDocument=gql`
    query SearchConfig {
  searchConfig {
    livePaletteKeywords
    keywordMinScore {
      keyword
      score
    }
    defaultMinScore
  }
}
    `;/**
 * __useSearchConfigQuery__
 *
 * To run a query within a React component, call `useSearchConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchConfigQuery({
 *   variables: {
 *   },
 * });
 */export function useSearchConfigQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SearchConfigDocument,options);}export function useSearchConfigLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SearchConfigDocument,options);}export const SignupDocument=gql`
    query Signup {
  requiredTerms: registTerms(type: REQUIRED) {
    ...termsFields
  }
  optionalTerms: registTerms(type: OPTIONAL) {
    ...termsFields
  }
  recommendArticle {
    courses {
      ... on Course {
        ...courseFields
      }
    }
    products {
      ... on Product {
        ...productFields
        right {
          ... on Right {
            ...rightFields
          }
        }
      }
    }
  }
}
    ${TermsFieldsFragmentDoc}
${CourseFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${RightFieldsFragmentDoc}`;/**
 * __useSignupQuery__
 *
 * To run a query within a React component, call `useSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupQuery({
 *   variables: {
 *   },
 * });
 */export function useSignupQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SignupDocument,options);}export function useSignupLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SignupDocument,options);}export const SubscribeDocument=gql`
    mutation Subscribe($courseId: Int, $paymentInstrumentId: Int, $voucherCode: String, $campaignCode: String, $valuePlanTerm: String) {
  subscribe(
    courseId: $courseId
    paymentInstrumentId: $paymentInstrumentId
    campaignCode: $campaignCode
    voucherCode: $voucherCode
    valuePlanTerm: $valuePlanTerm
  ) {
    subscription_id
    status
    initialTransactionAt
    trialStartAt
    trialEndAt
    init_order_id
    course {
      ...courseFields
    }
    orderPrice
    error
  }
}
    ${CourseFieldsFragmentDoc}`;/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      voucherCode: // value for 'voucherCode'
 *      campaignCode: // value for 'campaignCode'
 *      valuePlanTerm: // value for 'valuePlanTerm'
 *   },
 * });
 */export function useSubscribeMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(SubscribeDocument,options);}export const SubscriptionsDocument=gql`
    query Subscriptions {
  subscriptions {
    ...subscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */export function useSubscriptionsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SubscriptionsDocument,options);}export function useSubscriptionsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SubscriptionsDocument,options);}export const UnsubscribeDocument=gql`
    query Unsubscribe($id: Int) {
  subscription: subscriptionOne(id: $id) {
    ...subscriptionFields
  }
  checkCancelable: subscriptionCheckCancelable(subscriptionId: $id) {
    cancelable
    subscription {
      withdraw_at
    }
  }
}
    ${SubscriptionFieldsFragmentDoc}`;/**
 * __useUnsubscribeQuery__
 *
 * To run a query within a React component, call `useUnsubscribeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnsubscribeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */export function useUnsubscribeQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(UnsubscribeDocument,options);}export function useUnsubscribeLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(UnsubscribeDocument,options);}export const FormQuestionsDocument=gql`
    query FormQuestions($id: Int) {
  formQuestions(id: $id) {
    question_id
    data {
      type
      label
      unique
      key_name
      help_text
      required
      schema_group_name
      options {
        label
        value
      }
    }
    values
  }
}
    `;/**
 * __useFormQuestionsQuery__
 *
 * To run a query within a React component, call `useFormQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */export function useFormQuestionsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(FormQuestionsDocument,options);}export function useFormQuestionsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(FormQuestionsDocument,options);}export const SubscriptionCancelDocument=gql`
    mutation SubscriptionCancel($id: Int, $questionId: Int, $answer: String, $withQuestionAnswer: Boolean = false) {
  subscriptionCancel(id: $id) {
    course_id
    status
    withdraw_at
    error
  }
  formQuestionAnswer(id: $questionId, values: $answer) @include(if: $withQuestionAnswer) {
    answer_id
  }
}
    `;/**
 * __useSubscriptionCancelMutation__
 *
 * To run a mutation, you first call `useSubscriptionCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCancelMutation, { data, loading, error }] = useSubscriptionCancelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionId: // value for 'questionId'
 *      answer: // value for 'answer'
 *      withQuestionAnswer: // value for 'withQuestionAnswer'
 *   },
 * });
 */export function useSubscriptionCancelMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(SubscriptionCancelDocument,options);}export const SubscriptionChangePaymentDocument=gql`
    mutation SubscriptionChangePayment($paymentInstrumentId: Int!, $subscriptionId: Int!) {
  subscriptionChangePayment(
    paymentInstrumentId: $paymentInstrumentId
    subscriptionId: $subscriptionId
  ) {
    payment_instrument_id
    error
  }
}
    `;/**
 * __useSubscriptionChangePaymentMutation__
 *
 * To run a mutation, you first call `useSubscriptionChangePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionChangePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionChangePaymentMutation, { data, loading, error }] = useSubscriptionChangePaymentMutation({
 *   variables: {
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */export function useSubscriptionChangePaymentMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(SubscriptionChangePaymentDocument,options);}export const SubscriptionCheckCancelableDocument=gql`
    query SubscriptionCheckCancelable($subscriptionId: Int) {
  checkCancelable: subscriptionCheckCancelable(subscriptionId: $subscriptionId) {
    cancelable
    subscription {
      withdraw_at
    }
  }
}
    `;/**
 * __useSubscriptionCheckCancelableQuery__
 *
 * To run a query within a React component, call `useSubscriptionCheckCancelableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCheckCancelableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCheckCancelableQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */export function useSubscriptionCheckCancelableQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SubscriptionCheckCancelableDocument,options);}export function useSubscriptionCheckCancelableLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SubscriptionCheckCancelableDocument,options);}export const FormQuestionAnswerDocument=gql`
    mutation FormQuestionAnswer($values: String, $id: Int) {
  formQuestionAnswer(values: $values, id: $id) {
    answer_id
  }
}
    `;/**
 * __useFormQuestionAnswerMutation__
 *
 * To run a mutation, you first call `useFormQuestionAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormQuestionAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formQuestionAnswerMutation, { data, loading, error }] = useFormQuestionAnswerMutation({
 *   variables: {
 *      values: // value for 'values'
 *      id: // value for 'id'
 *   },
 * });
 */export function useFormQuestionAnswerMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(FormQuestionAnswerDocument,options);}export const SubscriptionStatusDocument=gql`
    query SubscriptionStatus($courseId: Int) {
  course: courseById(courseId: $courseId) {
    ... on Course {
      ...courseFields
    }
    channel {
      id
      name
    }
  }
  subscriptionStatus(courseId: $courseId) {
    is_contractable
    is_contracted
    have_be_contracted
    is_trial_enabled
    subscription {
      ...subscriptionFields
    }
  }
}
    ${CourseFieldsFragmentDoc}
${SubscriptionFieldsFragmentDoc}`;/**
 * __useSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionStatusQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */export function useSubscriptionStatusQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SubscriptionStatusDocument,options);}export function useSubscriptionStatusLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SubscriptionStatusDocument,options);}export const UnSubscribedStatusDocument=gql`
    query UnSubscribedStatus($courseId: Int) {
  unSubscribedStatus(courseId: $courseId) {
    ...subscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;/**
 * __useUnSubscribedStatusQuery__
 *
 * To run a query within a React component, call `useUnSubscribedStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnSubscribedStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnSubscribedStatusQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */export function useUnSubscribedStatusQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(UnSubscribedStatusDocument,options);}export function useUnSubscribedStatusLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(UnSubscribedStatusDocument,options);}export const SubscriptionEstimateDocument=gql`
    query SubscriptionEstimate($courseId: Int, $paymentMethodId: Int) {
  estimate: subscriptionEstimate(
    courseId: $courseId
    paymentMethodId: $paymentMethodId
  ) {
    ...estimateFields
  }
}
    ${EstimateFieldsFragmentDoc}`;/**
 * __useSubscriptionEstimateQuery__
 *
 * To run a query within a React component, call `useSubscriptionEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionEstimateQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */export function useSubscriptionEstimateQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SubscriptionEstimateDocument,options);}export function useSubscriptionEstimateLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SubscriptionEstimateDocument,options);}export const SubscriptionEstimateWithCouponDocument=gql`
    query SubscriptionEstimateWithCoupon($courseId: Int, $paymentMethodId: Int, $couponCode: String) {
  estimateWithCoupon: subscriptionEstimate(
    courseId: $courseId
    paymentMethodId: $paymentMethodId
    couponCode: $couponCode
  ) {
    ...estimateFields
  }
}
    ${EstimateFieldsFragmentDoc}`;/**
 * __useSubscriptionEstimateWithCouponQuery__
 *
 * To run a query within a React component, call `useSubscriptionEstimateWithCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionEstimateWithCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionEstimateWithCouponQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */export function useSubscriptionEstimateWithCouponQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(SubscriptionEstimateWithCouponDocument,options);}export function useSubscriptionEstimateWithCouponLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(SubscriptionEstimateWithCouponDocument,options);}export const TermsDocument=gql`
    query Terms($keys: [String], $withAgreement: Boolean = false) {
  terms(keys: $keys, withAgreement: $withAgreement) {
    ...termsFields
  }
}
    ${TermsFieldsFragmentDoc}`;/**
 * __useTermsQuery__
 *
 * To run a query within a React component, call `useTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsQuery({
 *   variables: {
 *      keys: // value for 'keys'
 *      withAgreement: // value for 'withAgreement'
 *   },
 * });
 */export function useTermsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(TermsDocument,options);}export function useTermsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(TermsDocument,options);}export const ValuePlanTermsDocument=gql`
    query ValuePlanTerms {
  terms(keys: ["valueplan_term"], withAgreement: true) {
    ...termsFields
  }
}
    ${TermsFieldsFragmentDoc}`;/**
 * __useValuePlanTermsQuery__
 *
 * To run a query within a React component, call `useValuePlanTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuePlanTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuePlanTermsQuery({
 *   variables: {
 *   },
 * });
 */export function useValuePlanTermsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ValuePlanTermsDocument,options);}export function useValuePlanTermsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ValuePlanTermsDocument,options);}export const RegistTermsDocument=gql`
    query RegistTerms {
  required: registTerms(type: REQUIRED) {
    ...termsFields
  }
  optional: registTerms(type: OPTIONAL) {
    ...termsFields
  }
}
    ${TermsFieldsFragmentDoc}`;/**
 * __useRegistTermsQuery__
 *
 * To run a query within a React component, call `useRegistTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistTermsQuery({
 *   variables: {
 *   },
 * });
 */export function useRegistTermsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(RegistTermsDocument,options);}export function useRegistTermsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(RegistTermsDocument,options);}export const LoginTermsDocument=gql`
    query LoginTerms($cacheMaxAge: Int) {
  required: loginTerms(type: REQUIRED, cacheMaxAge: $cacheMaxAge) {
    ...termsFields
  }
  optional: loginTerms(type: OPTIONAL, cacheMaxAge: $cacheMaxAge) {
    ...termsFields
  }
}
    ${TermsFieldsFragmentDoc}`;/**
 * __useLoginTermsQuery__
 *
 * To run a query within a React component, call `useLoginTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginTermsQuery({
 *   variables: {
 *      cacheMaxAge: // value for 'cacheMaxAge'
 *   },
 * });
 */export function useLoginTermsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(LoginTermsDocument,options);}export function useLoginTermsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(LoginTermsDocument,options);}export const TermsAgreeDocument=gql`
    mutation TermsAgree($keys: [String]) {
  agree(keys: $keys) {
    unique_key
    number
    url
    agreement {
      agreement_id
      user_id
      term_id
      term_revision_number
    }
  }
}
    `;/**
 * __useTermsAgreeMutation__
 *
 * To run a mutation, you first call `useTermsAgreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTermsAgreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [termsAgreeMutation, { data, loading, error }] = useTermsAgreeMutation({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */export function useTermsAgreeMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(TermsAgreeDocument,options);}export const TitleDocument=gql`
    query Title($id: Int, $withBookmark: Boolean = false, $withChildren: Boolean = false, $withCourse: Boolean = false) {
  title(id: $id) {
    ...tvShowMetaFields
    bookmark @include(if: $withBookmark) {
      meta_id
      bookmark_meta_id
      position
      bookmark_meta {
        ...episodeMetaFields
        ...liveMetaFields
      }
    }
    course @include(if: $withCourse) {
      ...courseFields
    }
  }
  children(id: $id, offset: 0, limit: 10) @include(if: $withChildren) {
    data {
      ...episodeMetaFields
      ...liveMetaFields
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${TvShowMetaFieldsFragmentDoc}
${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${CourseFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useTitleQuery__
 *
 * To run a query within a React component, call `useTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withBookmark: // value for 'withBookmark'
 *      withChildren: // value for 'withChildren'
 *      withCourse: // value for 'withCourse'
 *   },
 * });
 */export function useTitleQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(TitleDocument,options);}export function useTitleLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(TitleDocument,options);}export const TitlesDocument=gql`
    query Titles($filter: JSONObject, $sort: String, $offset: Int, $limit: Int) {
  titles(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    data {
      ...tvShowMetaFields
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${TvShowMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useTitlesQuery__
 *
 * To run a query within a React component, call `useTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function useTitlesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(TitlesDocument,options);}export function useTitlesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(TitlesDocument,options);}export const AuthLoginDocument=gql`
    mutation AuthLogin($loginid: String!, $password: String!, $signature: String!) {
  login(loginid: $loginid, password: $password, signature: $signature) {
    token
    error {
      code
    }
  }
}
    `;/**
 * __useAuthLoginMutation__
 *
 * To run a mutation, you first call `useAuthLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginMutation, { data, loading, error }] = useAuthLoginMutation({
 *   variables: {
 *      loginid: // value for 'loginid'
 *      password: // value for 'password'
 *      signature: // value for 'signature'
 *   },
 * });
 */export function useAuthLoginMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AuthLoginDocument,options);}export const AuthUserDocument=gql`
    query AuthUser {
  user {
    ...accountFields
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useAuthUserQuery__
 *
 * To run a query within a React component, call `useAuthUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserQuery({
 *   variables: {
 *   },
 * });
 */export function useAuthUserQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(AuthUserDocument,options);}export function useAuthUserLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(AuthUserDocument,options);}export const AuthUserWithFavoritesDocument=gql`
    query AuthUserWithFavorites {
  user {
    ...accountFields
  }
  favorites: userFavorites {
    ...userFavoritesFields
  }
}
    ${AccountFieldsFragmentDoc}
${UserFavoritesFieldsFragmentDoc}`;/**
 * __useAuthUserWithFavoritesQuery__
 *
 * To run a query within a React component, call `useAuthUserWithFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserWithFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserWithFavoritesQuery({
 *   variables: {
 *   },
 * });
 */export function useAuthUserWithFavoritesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(AuthUserWithFavoritesDocument,options);}export function useAuthUserWithFavoritesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(AuthUserWithFavoritesDocument,options);}export const AuthLogoutDocument=gql`
    mutation AuthLogout($force: Boolean = false) {
  logout(force: $force) {
    result
  }
}
    `;/**
 * __useAuthLogoutMutation__
 *
 * To run a mutation, you first call `useAuthLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLogoutMutation, { data, loading, error }] = useAuthLogoutMutation({
 *   variables: {
 *      force: // value for 'force'
 *   },
 * });
 */export function useAuthLogoutMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AuthLogoutDocument,options);}export const AuthSelectProfileDocument=gql`
    mutation AuthSelectProfile($profileId: Int!, $passcode: String, $type: String) {
  selectProfile(profileId: $profileId, passcode: $passcode, type: $type) {
    ...accountFields
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useAuthSelectProfileMutation__
 *
 * To run a mutation, you first call `useAuthSelectProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSelectProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSelectProfileMutation, { data, loading, error }] = useAuthSelectProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      passcode: // value for 'passcode'
 *      type: // value for 'type'
 *   },
 * });
 */export function useAuthSelectProfileMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AuthSelectProfileDocument,options);}export const AuthProfileDocument=gql`
    mutation AuthProfile($profileId: Int, $passcode: String) {
  authProfile(profileId: $profileId, passcode: $passcode) {
    result
  }
}
    `;/**
 * __useAuthProfileMutation__
 *
 * To run a mutation, you first call `useAuthProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authProfileMutation, { data, loading, error }] = useAuthProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */export function useAuthProfileMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AuthProfileDocument,options);}export const AccountSignupPinCodeDocument=gql`
    mutation AccountSignupPinCode($mailAddress: String!) {
  signupPincode(mailAddress: $mailAddress) {
    result
  }
}
    `;/**
 * __useAccountSignupPinCodeMutation__
 *
 * To run a mutation, you first call `useAccountSignupPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSignupPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSignupPinCodeMutation, { data, loading, error }] = useAccountSignupPinCodeMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */export function useAccountSignupPinCodeMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountSignupPinCodeDocument,options);}export const AccountSendPinCodeDocument=gql`
    mutation AccountSendPinCode($mailAddress: String!) {
  sendPincode(mailAddress: $mailAddress) {
    result
  }
}
    `;/**
 * __useAccountSendPinCodeMutation__
 *
 * To run a mutation, you first call `useAccountSendPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendPinCodeMutation, { data, loading, error }] = useAccountSendPinCodeMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */export function useAccountSendPinCodeMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountSendPinCodeDocument,options);}export const AccountSendProfilePinResetTokenDocument=gql`
    mutation AccountSendProfilePinResetToken {
  sendProfilePinResetToken {
    result
  }
}
    `;/**
 * __useAccountSendProfilePinResetTokenMutation__
 *
 * To run a mutation, you first call `useAccountSendProfilePinResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendProfilePinResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendProfilePinResetTokenMutation, { data, loading, error }] = useAccountSendProfilePinResetTokenMutation({
 *   variables: {
 *   },
 * });
 */export function useAccountSendProfilePinResetTokenMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountSendProfilePinResetTokenDocument,options);}export const AccountSendPasswordResetTokenDocument=gql`
    mutation AccountSendPasswordResetToken($mailAddress: String!) {
  sendPasswordResetToken(mailAddress: $mailAddress) {
    result
  }
}
    `;/**
 * __useAccountSendPasswordResetTokenMutation__
 *
 * To run a mutation, you first call `useAccountSendPasswordResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendPasswordResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendPasswordResetTokenMutation, { data, loading, error }] = useAccountSendPasswordResetTokenMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */export function useAccountSendPasswordResetTokenMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountSendPasswordResetTokenDocument,options);}export const AccountPasswordResetDocument=gql`
    mutation AccountPasswordReset($password: String!, $token: String!) {
  passwordReset(password: $password, token: $token) {
    result
  }
}
    `;/**
 * __useAccountPasswordResetMutation__
 *
 * To run a mutation, you first call `useAccountPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPasswordResetMutation, { data, loading, error }] = useAccountPasswordResetMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */export function useAccountPasswordResetMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountPasswordResetDocument,options);}export const AccountPasscodeResetDocument=gql`
    mutation AccountPasscodeReset($passcode: String!, $token: String!) {
  passcodeReset(passcode: $passcode, token: $token) {
    result
  }
}
    `;/**
 * __useAccountPasscodeResetMutation__
 *
 * To run a mutation, you first call `useAccountPasscodeResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPasscodeResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPasscodeResetMutation, { data, loading, error }] = useAccountPasscodeResetMutation({
 *   variables: {
 *      passcode: // value for 'passcode'
 *      token: // value for 'token'
 *   },
 * });
 */export function useAccountPasscodeResetMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountPasscodeResetDocument,options);}export const AccountVerifyPinCodeDocument=gql`
    mutation AccountVerifyPinCode($code: String!, $mailAddress: String!) {
  verifyPinCode(code: $code, mailAddress: $mailAddress) {
    verified
    error
  }
}
    `;/**
 * __useAccountVerifyPinCodeMutation__
 *
 * To run a mutation, you first call `useAccountVerifyPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountVerifyPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountVerifyPinCodeMutation, { data, loading, error }] = useAccountVerifyPinCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */export function useAccountVerifyPinCodeMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountVerifyPinCodeDocument,options);}export const AccountVerifyPasswordTokenDocument=gql`
    mutation AccountVerifyPasswordToken($token: String!) {
  verifyPasswordToken(token: $token) {
    verified
    error
  }
}
    `;/**
 * __useAccountVerifyPasswordTokenMutation__
 *
 * To run a mutation, you first call `useAccountVerifyPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountVerifyPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountVerifyPasswordTokenMutation, { data, loading, error }] = useAccountVerifyPasswordTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */export function useAccountVerifyPasswordTokenMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountVerifyPasswordTokenDocument,options);}export const AccountSignupDocument=gql`
    mutation AccountSignup($code: String!, $mailAddress: String!, $password: String!, $firstName: String!, $lastName: String!, $birthday: String!, $sex: String!, $terms: String!, $signature: String!) {
  signup(
    code: $code
    mailAddress: $mailAddress
    password: $password
    firstName: $firstName
    lastName: $lastName
    birthday: $birthday
    sex: $sex
    terms: $terms
    signature: $signature
  ) {
    token
    user {
      ...accountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useAccountSignupMutation__
 *
 * To run a mutation, you first call `useAccountSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSignupMutation, { data, loading, error }] = useAccountSignupMutation({
 *   variables: {
 *      code: // value for 'code'
 *      mailAddress: // value for 'mailAddress'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      terms: // value for 'terms'
 *      signature: // value for 'signature'
 *   },
 * });
 */export function useAccountSignupMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountSignupDocument,options);}export const AddFavoriteDocument=gql`
    mutation AddFavorite($id: Int!) {
  addFavorite(id: $id) {
    result
    favorites {
      ...userFavoritesFields
    }
  }
}
    ${UserFavoritesFieldsFragmentDoc}`;/**
 * __useAddFavoriteMutation__
 *
 * To run a mutation, you first call `useAddFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteMutation, { data, loading, error }] = useAddFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */export function useAddFavoriteMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AddFavoriteDocument,options);}export const DeleteFavoriteDocument=gql`
    mutation DeleteFavorite($id: Int!) {
  deleteFavorite(id: $id) {
    result
    favorites {
      ...userFavoritesFields
    }
  }
}
    ${UserFavoritesFieldsFragmentDoc}`;/**
 * __useDeleteFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteMutation, { data, loading, error }] = useDeleteFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */export function useDeleteFavoriteMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(DeleteFavoriteDocument,options);}export const FavoritesByContentTypeDocument=gql`
    query FavoritesByContentType($type: String, $offset: Int, $limit: Int) {
  favorites: favoritesByContentType(type: $type, offset: $offset, limit: $limit) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
      ... on TVShowMeta {
        ...tvShowMetaFields
      }
      ... on ChannelMeta {
        ...channelMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${ChannelMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useFavoritesByContentTypeQuery__
 *
 * To run a query within a React component, call `useFavoritesByContentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesByContentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesByContentTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */export function useFavoritesByContentTypeQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(FavoritesByContentTypeDocument,options);}export function useFavoritesByContentTypeLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(FavoritesByContentTypeDocument,options);}export const ViewingHistoriesDocument=gql`
    query ViewingHistories($offset: Int, $limit: Int, $sort: String, $nocache: Boolean = false) {
  viewingHistories(offset: $offset, limit: $limit, sort: $sort, nocache: $nocache) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
        resume_point
        last_viewing_at
      }
      ... on LiveMeta {
        ...liveMetaFields
        resume_point
        last_viewing_at
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;/**
 * __useViewingHistoriesQuery__
 *
 * To run a query within a React component, call `useViewingHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewingHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewingHistoriesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      nocache: // value for 'nocache'
 *   },
 * });
 */export function useViewingHistoriesQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(ViewingHistoriesDocument,options);}export function useViewingHistoriesLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(ViewingHistoriesDocument,options);}export const DeleteViewingHistoryDocument=gql`
    mutation DeleteViewingHistory($metaIds: [String]) {
  deleteViewingHistory(metaIds: $metaIds) {
    result
  }
}
    `;/**
 * __useDeleteViewingHistoryMutation__
 *
 * To run a mutation, you first call `useDeleteViewingHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewingHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewingHistoryMutation, { data, loading, error }] = useDeleteViewingHistoryMutation({
 *   variables: {
 *      metaIds: // value for 'metaIds'
 *   },
 * });
 */export function useDeleteViewingHistoryMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(DeleteViewingHistoryDocument,options);}export const AddResumeDocument=gql`
    mutation AddResume($resume: Int, $metaId: Int, $groupedMetaId: Int, $psid: String, $reachToEnd: Boolean) {
  addResume(
    resume: $resume
    metaId: $metaId
    groupedMetaId: $groupedMetaId
    psid: $psid
    reachToEnd: $reachToEnd
  ) {
    result
  }
}
    `;/**
 * __useAddResumeMutation__
 *
 * To run a mutation, you first call `useAddResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeMutation, { data, loading, error }] = useAddResumeMutation({
 *   variables: {
 *      resume: // value for 'resume'
 *      metaId: // value for 'metaId'
 *      groupedMetaId: // value for 'groupedMetaId'
 *      psid: // value for 'psid'
 *      reachToEnd: // value for 'reachToEnd'
 *   },
 * });
 */export function useAddResumeMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AddResumeDocument,options);}export const AccountUpdateDocument=gql`
    mutation AccountUpdate($mailAddress: String, $code: String) {
  update(mailAddress: $mailAddress, code: $code) {
    user {
      ...accountFields
    }
    error
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useAccountUpdateMutation__
 *
 * To run a mutation, you first call `useAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateMutation, { data, loading, error }] = useAccountUpdateMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *      code: // value for 'code'
 *   },
 * });
 */export function useAccountUpdateMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountUpdateDocument,options);}export const AccountUpdatePasswordDocument=gql`
    mutation AccountUpdatePassword($currentPassword: String, $password: String) {
  updatePassword(currentPassword: $currentPassword, password: $password) {
    user {
      ...accountFields
    }
    error
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useAccountUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAccountUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdatePasswordMutation, { data, loading, error }] = useAccountUpdatePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password: // value for 'password'
 *   },
 * });
 */export function useAccountUpdatePasswordMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountUpdatePasswordDocument,options);}export const AccountUpdateOwnerProfileDocument=gql`
    mutation AccountUpdateOwnerProfile($displayName: String, $icon: Int, $passcode: String, $rating: Int) {
  updateOwnerProfile(
    displayName: $displayName
    icon: $icon
    passcode: $passcode
    rating: $rating
  ) {
    user {
      ...accountFields
    }
    error
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useAccountUpdateOwnerProfileMutation__
 *
 * To run a mutation, you first call `useAccountUpdateOwnerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateOwnerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateOwnerProfileMutation, { data, loading, error }] = useAccountUpdateOwnerProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      icon: // value for 'icon'
 *      passcode: // value for 'passcode'
 *      rating: // value for 'rating'
 *   },
 * });
 */export function useAccountUpdateOwnerProfileMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountUpdateOwnerProfileDocument,options);}export const AccountAddProfileDocument=gql`
    mutation AccountAddProfile($displayName: String, $birthday: String, $sex: String, $icon: Int, $rating: Int, $passcode: String) {
  addProfile(
    displayName: $displayName
    birthday: $birthday
    sex: $sex
    icon: $icon
    rating: $rating
    passcode: $passcode
  ) {
    profile {
      ...profileFields
    }
  }
}
    ${ProfileFieldsFragmentDoc}`;/**
 * __useAccountAddProfileMutation__
 *
 * To run a mutation, you first call `useAccountAddProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddProfileMutation, { data, loading, error }] = useAccountAddProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      icon: // value for 'icon'
 *      rating: // value for 'rating'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */export function useAccountAddProfileMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountAddProfileDocument,options);}export const AccountUpdateProfileDocument=gql`
    mutation AccountUpdateProfile($displayName: String, $birthday: String, $sex: String, $password: String, $profileId: Int, $icon: Int, $rating: Int, $passcode: String) {
  updateProfile(
    displayName: $displayName
    birthday: $birthday
    sex: $sex
    password: $password
    profileId: $profileId
    icon: $icon
    rating: $rating
    passcode: $passcode
  ) {
    profile {
      ...profileFields
    }
  }
}
    ${ProfileFieldsFragmentDoc}`;/**
 * __useAccountUpdateProfileMutation__
 *
 * To run a mutation, you first call `useAccountUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateProfileMutation, { data, loading, error }] = useAccountUpdateProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      password: // value for 'password'
 *      profileId: // value for 'profileId'
 *      icon: // value for 'icon'
 *      rating: // value for 'rating'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */export function useAccountUpdateProfileMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountUpdateProfileDocument,options);}export const AccountDeleteProfileDocument=gql`
    mutation AccountDeleteProfile($profileId: Int) {
  deleteProfile(profileId: $profileId) {
    result
  }
}
    `;/**
 * __useAccountDeleteProfileMutation__
 *
 * To run a mutation, you first call `useAccountDeleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountDeleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountDeleteProfileMutation, { data, loading, error }] = useAccountDeleteProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */export function useAccountDeleteProfileMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountDeleteProfileDocument,options);}export const AccountUserDeleteDocument=gql`
    mutation AccountUserDelete {
  userDelete {
    result
  }
}
    `;/**
 * __useAccountUserDeleteMutation__
 *
 * To run a mutation, you first call `useAccountUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserDeleteMutation, { data, loading, error }] = useAccountUserDeleteMutation({
 *   variables: {
 *   },
 * });
 */export function useAccountUserDeleteMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountUserDeleteDocument,options);}export const UserEntitlementsDocument=gql`
    query UserEntitlements {
  entitlements: userEntitlements {
    ...entitlementFields
  }
}
    ${EntitlementFieldsFragmentDoc}`;/**
 * __useUserEntitlementsQuery__
 *
 * To run a query within a React component, call `useUserEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEntitlementsQuery({
 *   variables: {
 *   },
 * });
 */export function useUserEntitlementsQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(UserEntitlementsDocument,options);}export function useUserEntitlementsLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(UserEntitlementsDocument,options);}export const AccountAdvertisingPreferencesDocument=gql`
    mutation AccountAdvertisingPreferences($receiveAdvertisingMailFlag: Boolean) {
  advertisingPreferences(receiveAdvertisingMailFlag: $receiveAdvertisingMailFlag) {
    request_id
  }
}
    `;/**
 * __useAccountAdvertisingPreferencesMutation__
 *
 * To run a mutation, you first call `useAccountAdvertisingPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAdvertisingPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAdvertisingPreferencesMutation, { data, loading, error }] = useAccountAdvertisingPreferencesMutation({
 *   variables: {
 *      receiveAdvertisingMailFlag: // value for 'receiveAdvertisingMailFlag'
 *   },
 * });
 */export function useAccountAdvertisingPreferencesMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountAdvertisingPreferencesDocument,options);}export const CheckTokenTimeoutDocument=gql`
    query CheckTokenTimeout {
  checkTokenTimeout {
    result
  }
}
    `;/**
 * __useCheckTokenTimeoutQuery__
 *
 * To run a query within a React component, call `useCheckTokenTimeoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTokenTimeoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTokenTimeoutQuery({
 *   variables: {
 *   },
 * });
 */export function useCheckTokenTimeoutQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(CheckTokenTimeoutDocument,options);}export function useCheckTokenTimeoutLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(CheckTokenTimeoutDocument,options);}export const RefreshTokenDocument=gql`
    mutation RefreshToken {
  refreshToken {
    result
  }
}
    `;/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */export function useRefreshTokenMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(RefreshTokenDocument,options);}export const IdcTokenLoginDocument=gql`
    mutation IdcTokenLogin($signature: String!) {
  idcTokenLogin(signature: $signature) {
    token
    user {
      ...accountFields
    }
    error {
      code
    }
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useIdcTokenLoginMutation__
 *
 * To run a mutation, you first call `useIdcTokenLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdcTokenLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [idcTokenLoginMutation, { data, loading, error }] = useIdcTokenLoginMutation({
 *   variables: {
 *      signature: // value for 'signature'
 *   },
 * });
 */export function useIdcTokenLoginMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(IdcTokenLoginDocument,options);}export const AccountIdcTokenSignupDocument=gql`
    mutation AccountIdcTokenSignup($password: String!, $terms: String!, $signature: String!) {
  idcTokenSignup(password: $password, terms: $terms, signature: $signature) {
    token
    user {
      ...accountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useAccountIdcTokenSignupMutation__
 *
 * To run a mutation, you first call `useAccountIdcTokenSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountIdcTokenSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountIdcTokenSignupMutation, { data, loading, error }] = useAccountIdcTokenSignupMutation({
 *   variables: {
 *      password: // value for 'password'
 *      terms: // value for 'terms'
 *      signature: // value for 'signature'
 *   },
 * });
 */export function useAccountIdcTokenSignupMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(AccountIdcTokenSignupDocument,options);}export const SpooxIdIdcTokenMappingDocument=gql`
    mutation SpooxIdIdcTokenMapping($signature: String!) {
  idcTokenMapping(signature: $signature) {
    user {
      ...accountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;/**
 * __useSpooxIdIdcTokenMappingMutation__
 *
 * To run a mutation, you first call `useSpooxIdIdcTokenMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpooxIdIdcTokenMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spooxIdIdcTokenMappingMutation, { data, loading, error }] = useSpooxIdIdcTokenMappingMutation({
 *   variables: {
 *      signature: // value for 'signature'
 *   },
 * });
 */export function useSpooxIdIdcTokenMappingMutation(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useMutation(SpooxIdIdcTokenMappingDocument,options);}export const WatchDocument=gql`
    query Watch($id: Int) {
  episode(id: $id) {
    ...episodeMetaFields
    ...liveMetaFields
  }
  nextEpisode(id: $id) {
    ...episodeMetaFields
    ...liveMetaFields
  }
  howtoPlay(id: $id) {
    free
    member_only
    rights {
      ...rightFields
    }
    courses {
      ...courseFields
    }
    products {
      ...productFields
    }
  }
  entitlements(metaId: $id) {
    ...entitlementFields
  }
  uid2Token {
    token
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${RightFieldsFragmentDoc}
${CourseFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${EntitlementFieldsFragmentDoc}`;/**
 * __useWatchQuery__
 *
 * To run a query within a React component, call `useWatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */export function useWatchQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(WatchDocument,options);}export function useWatchLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(WatchDocument,options);}export const WebPageDocument=gql`
    query WebPage($path: String) {
  webPage(path: $path) {
    id
    content
    style
    script
    metatags {
      robots
      canonicalUrl
      title
      keywords
      description
    }
  }
}
    `;/**
 * __useWebPageQuery__
 *
 * To run a query within a React component, call `useWebPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebPageQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */export function useWebPageQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(WebPageDocument,options);}export function useWebPageLazyQuery(baseOptions){const options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(WebPageDocument,options);}